import React, { useState, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { RateShoppedService } from './rate-shopped-service';
import { Button } from 'ui-components/components/button';
import style from './style.module.css';
import { messages } from './messages';

const ERRORED_OR_INVALID = 'ErroredOrInvalid';
const totalShownWhenCollapsed = 5;

export const ServiceComparison = ({ services }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const serviceSelectedByRateShopper = useMemo(() => services.find((service) => service.rejectReasons.length === 0), [services]);
  const filteredServicesWithoutErrors = useMemo(
    () => services.filter((service) => !service.rejectReasons.includes(ERRORED_OR_INVALID) && service !== serviceSelectedByRateShopper),
    [services, serviceSelectedByRateShopper],
  );
  const filteredServicesWithErrors = useMemo(
    () => services.filter((service) => service.rejectReasons.includes(ERRORED_OR_INVALID) && service !== serviceSelectedByRateShopper),
    [services, serviceSelectedByRateShopper],
  );
  const totalServiceCount = services.length;
  const maxShowableServices = isExpanded ? filteredServicesWithoutErrors.length : totalShownWhenCollapsed - 1; // subtract the winner as it is always shown
  const shouldShowExpandCollapseLink = totalServiceCount > totalShownWhenCollapsed || filteredServicesWithErrors.length > 0;
  const onExpandCollapseChange = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);
  const expandContractLinkText = isExpanded ? messages.showLessLinkText : messages.showMoreLinkText;
  return (
    <div className={style['service-comparison']}>
      <div className={style['row-header']}>
        <div>
          <FormattedMessage {...messages.serviceHeaderText} />
        </div>
        <div>
          <FormattedMessage {...messages.deliveryDateHeaderText} />
        </div>
        <div className={style['align-right']}>
          <FormattedMessage {...messages.totalCostHeaderText} />
        </div>
      </div>
      <RateShoppedService isHighlighted rateShoppedService={serviceSelectedByRateShopper} />
      <div className={style['scrollable-section']}>
        {filteredServicesWithoutErrors
          .sort((a, b) => a.totalCost - b.totalCost)
          .map((service, index) =>
            index + 1 <= maxShowableServices ? <RateShoppedService key={index} rateShoppedService={service} /> : null,
          )}
        {isExpanded &&
          filteredServicesWithErrors.map((service, index) => <RateShoppedService key={index} hasError rateShoppedService={service} />)}
      </div>
      {shouldShowExpandCollapseLink && (
        <div className={style['show-hide-link']}>
          <Button onClick={onExpandCollapseChange} theme='link'>
            <FormattedMessage {...expandContractLinkText} />
          </Button>
        </div>
      )}
    </div>
  );
};
